import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { PageLabelsAutomationDiscoveryProps } from '../src/PageLabelsAutomationDiscovery.tsx';
export { PageLabelsAutomationDiscovery } from '../src/PageLabelsAutomationDiscovery.tsx';
export const LazyPageLabelsAutomationDiscovery: LoadableType<PageLabelsAutomationDiscoveryProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PageLabelsAutomationDiscovery" */ '../src/PageLabelsAutomationDiscovery.tsx'
				)
			).PageLabelsAutomationDiscovery,
	});
